import { render, staticRenderFns } from "./ForgetByInfo.vue?vue&type=template&id=14257ac8&scoped=true&"
import script from "./ForgetByInfo.vue?vue&type=script&lang=js&"
export * from "./ForgetByInfo.vue?vue&type=script&lang=js&"
import style0 from "./ForgetByInfo.vue?vue&type=style&index=0&id=14257ac8&prod&lang=css&"
import style1 from "./ForgetByInfo.vue?vue&type=style&index=1&id=14257ac8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14257ac8",
  null
  
)

export default component.exports